import { isLocalMode } from '@/local';
import { apiFetch } from './apiBase';
import {
  localGetModelSettings,
  localPutModelSettings,
} from '@/local/localBackend';

export interface ModelSettings {
  imageModel: string;
  videoFastModel: string;
  videoFullModel: string;
}

export async function getModelSettings(): Promise<ModelSettings> {
  if (isLocalMode()) return localGetModelSettings();
  const res = await apiFetch('/api/admin/settings/models');
  if (!res.ok) throw new Error(`getModelSettings failed: ${res.status}`);
  return res.json();
}

export async function putModelSettings(input: ModelSettings): Promise<ModelSettings> {
  if (isLocalMode()) return localPutModelSettings(input);
  const res = await apiFetch('/api/admin/settings/models', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  if (!res.ok) throw new Error(`putModelSettings failed: ${res.status}`);
  return res.json();
}
